import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { useInterval } from "react-use";
import classnames from "classnames";
import { Title } from "../../components/NewTitle";
import { JonusExperienceScroll } from "../joinus-experience-scroll";
// import { SilderDot } from "../../components/SilderDot";

export const JoinusExperience = () => {
  const { t } = useTranslation();
  const [element, setElement] = useState(1);
  const commonList = [
    {
      common: `${t("page.other.item-one.common")}`,
      author: `—— ${t("page.other.item-one.author")}`,
      urlimg: "//files.authing.co/authing-website/joinus-comment-01.png",
    },
    {
      common: `${t("page.other.item-two.common")}`,
      author: `—— ${t("page.other.item-two.author")}`,
      urlimg: "//files.authing.co/authing-website/joinus-common-02.png",
      // urlimg: "//files.authing.co/authing-website/home-customer-amazon.png",
    },
    {
      common: `${t("page.other.item-three.common")}`,
      author: `—— ${t("page.other.item-three.author")}`,
      urlimg: "//files.authing.co/authing-website/joinus-comment-03.png",
    },
    {
      common: `${t("page.other.item-four.common")}`,
      author: `—— ${t("page.other.item-four.author")}`,
      urlimg: "//files.authing.co/authing-website/joinus-comment-04.png",
    },
  ];
  const commonIndexList = [
    { imgUrl: "//files.authing.co/authing-website/home-logo-dongnan.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-aws.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-education.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-zhijiang.png" },
  ];
  useInterval(() => {
    if (element < 4) {
      setElement(element + 1);
    } else {
      setElement(1);
    }
  }, 8000);
  const onMouseLeave = () => {};
  const SilderDot = () => {
    return (
      <div className={classnames("dot-container")}>
        {commonIndexList?.map((item, index) => {
          return (
            <div>
              <div
                key={index}
                className={classnames("item-dot", {
                  active: element - 1 === index,
                })}
                onMouseEnter={() => setElement(index + 1)}
                onMouseLeave={onMouseLeave}
              >
                {/* <img src={item.imgUrl} alt="" width="150px" /> */}
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const renderJoinusPC = () => {
    return (
      <div className="joinus-experience-pc">
        <div className="common-warp">
          {commonList.map((item, index) => {
            const cls = classnames({
              common: true,
              visible: element === index + 1,
            });
            return (
              <div className={cls}>
                <div className="common-icon">
                  <img src={item.urlimg} alt="authing joinus experience" />
                </div>
              </div>
            );
          })}
        </div>
        {SilderDot()}
      </div>
    );
  };
  return (
    <div className="juinus-comment-block">
      <div className="inner">
        <section className="common-section">
          <Title title={t("joinus.comment.title")} />
          {renderJoinusPC()}
          <JonusExperienceScroll />
        </section>
      </div>
    </div>
  );
};
